import _ from 'underscore'
import React from 'react'
import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

type Props = {
  selectedRoles: Array<string>,
  onChangeCallback: (attributes: { roles: Array<string> }) => void,
  errors?: { roles?: string } | null,
}

const roleDisplayName: Record<string, string> = {
  dealer: 'Dealer',
  fsr: 'FSR',
  technician: 'Technician'
}

const RoleFields = ({ selectedRoles, onChangeCallback, errors = {} } : Props) => {
  const allRoles = ['dealer', 'fsr', 'technician']

  const onRoleChange = (role: string) => {
    const updatedSelectedRoles = _.contains(selectedRoles, role)
      ? _.without(selectedRoles, role)
      : _.union(selectedRoles, [role])

    onChangeCallback({ roles: updatedSelectedRoles })
  }

  return (
    <FormSection title="Roles">
      {
        allRoles.map((role) => (
          <Checkbox
            key={role}
            label={roleDisplayName[role]}
            checked={selectedRoles.includes(role)}
            onChange={() => onRoleChange(role)}
            errorMessage={_.last(allRoles) === role ? errors?.roles : undefined}
          /> // TODO: DWA-2639 refactor to wrap set of checkboxes in container and have one error field for container
        ))
      }
    </FormSection>
  )
}

export default RoleFields
